// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".appraisals {\n  padding: 2rem 0;\n}\n\ntable {\n  display: table;\n  border-collapse: separate;\n  box-sizing: border-box;\n  text-indent: initial;\n  white-space-collapse: collapse;\n  text-wrap: wrap;\n  line-height: normal;\n  font-weight: normal;\n  font-size: medium;\n  font-style: normal;\n  color: -internal-quirk-inherit;\n  text-align: start;\n  border-spacing: 2px;\n  border-color: gray;\n  font-variant: normal;\n}\n", ""]);
// Exports
module.exports = exports;
